import React from 'react';
import PropTypes from 'prop-types';
import quotation from '../../../assets/brush/brush-quotation.png';

import {
  Wrapper,
  ImageWrapper,
  Image,
  TextWrapper,
  StyledRichText,
  Author,
  BrushElement,
  TopLine,
} from './styles';

const Testimonial = ({ data, slider = {}, isOdd, sidebar, position }) => {
  const { arrows, isSlider } = slider;
  const {
    image,
    text,
    author,
    alignImage = 'center',
    quoteSymbol = true,
  } = data;

  return (
    <Wrapper $isSlider={isSlider} $isOdd={isOdd} $sidebar={sidebar}>
      <ImageWrapper $sidebar={sidebar}>
        {image ? (
          <Image $image={image} $alignImage={alignImage} $sidebar={sidebar} />
        ) : null}
      </ImageWrapper>
      <TextWrapper>
        {quoteSymbol || isSlider ? (
          <TopLine>
            {quoteSymbol ? <BrushElement src={quotation} alt="" /> : null}
            {isSlider && arrows ? arrows(position) : null}
          </TopLine>
        ) : null}
        <StyledRichText richText={text} />
        {author ? <Author>&mdash; {author}</Author> : null}
      </TextWrapper>
    </Wrapper>
  );
};

Testimonial.propTypes = {
  data: PropTypes.shape({
    image: PropTypes.object.isRequired,
    text: PropTypes.object.isRequired,
    author: PropTypes.string,
    quoteSymbol: PropTypes.bool,
    alignImage: PropTypes.string,
  }),
  isOdd: PropTypes.bool,
  sidebar: PropTypes.bool,
  slider: PropTypes.shape({
    arrows: PropTypes.func,
    isSlider: PropTypes.bool,
  }),
  position: PropTypes.number,
};

export default Testimonial;
